import FormField, { FormFieldType } from "./FormField";
import TableHeader, { DefaultActionsHeader } from "./TableHeader";

export const CrusadeCampaignTableHeaders: TableHeader[] = [
  { text: "Campaign Name", value: "name", sortable: true },
  { text: "Description", value: "description", sortable: true },
  DefaultActionsHeader,
];

export const CrusadeCampaignFormFields: FormField[] = [
  {
    label: "Campaign Name",
    valueField: "name",
    type: FormFieldType.TEXT,
    required: true,
  },
  {
    label: "Description",
    valueField: "description",
    type: FormFieldType.TEXTAREA,
  },
];
